import { Box, Typography } from "@mui/material";
import React from "react";
import { Property } from "@stratify/shared";
import { PropertyBreadcrumbNav } from "./PropertyBreadcrumbNav";

interface PropertyPageHeaderProps {
  property: Property;
}

export const PropertyPageHeader: React.FC<PropertyPageHeaderProps> = ({
  property,
}) => {
  // Determine primary identifier - prefer address, fallback to strata plan
  const primaryIdentifier = property.address || property.strataPlanNumber || "Unknown Property";

  return (
    <Box>
      <PropertyBreadcrumbNav property={property} />
      <Box sx={{ mt: 2 }}>
        <Typography 
          variant="h4" 
          component="h1" 
          data-testid="property-page-title"
          sx={{ 
            fontWeight: 500,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
        >
          {primaryIdentifier}
        </Typography>
        {property.address && property.strataPlanNumber && (
          <Typography 
            variant="subtitle1" 
            color="text.secondary" 
            sx={{ mt: 0.5 }}
            data-testid="property-page-subtitle"
          >
            Strata Plan: {property.strataPlanNumber}
          </Typography>
        )}
      </Box>
    </Box>
  );
};